import { useEffect, useState } from "react";
import LinearProgressWithLabel from "./LinearProgressWithLabel";
import { Box } from "@mui/material";

export default function LinearWithValueLabel({ loading, completed }: { loading: boolean; completed: boolean }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!loading) {
      setProgress(0);
      return;
    }

    if (completed) {
      setProgress(100);
      return;
    }

    const timer = setInterval(() => {
      setProgress((prev: number) => {
        if (prev >= 95) return prev;
        const increment = Math.max(0.5, (100 - prev) * 0.02);
        return Math.min(prev + increment, 95);
      });
    }, 200);

    return () => clearInterval(timer);
  }, [loading, completed]);

  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
}
